'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentYandexpayAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M39.4146 36.4186H42.145V31.3304H45.0299C48.511 31.3304 50.3803 29.2422 50.3803 26.3451C50.3803 23.4701 48.533 21.3599 45.0667 21.3599H39.4146V36.4186ZM42.145 29.0878V23.6393H44.6472C46.6932 23.6393 47.5984 24.7422 47.5984 26.3451C47.5984 27.9481 46.6932 29.0878 44.6619 29.0878H42.145Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M53.0076 36.4186L54.2514 32.7054H59.9182L61.1693 36.4186H64.0837L58.7701 21.3599H55.3994L50.0932 36.4186H53.0076ZM54.9873 30.5142L57.0259 24.4481H57.1436L59.1822 30.5142H54.9873Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M63.5004 21.3599L68.9832 30.801V36.4186H71.7063V30.801L77.1891 21.3599H74.1055L70.4183 28.0216H70.2712L66.584 21.3599H63.5004Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ jsx("circle", { cx: 19.8255, cy: 28.8255, r: 12.8255, fill: "#FC3F1D" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M24.8182 36.3636H22.1758V23.2653H20.9958C18.8353 23.2653 17.7052 24.3471 17.7052 25.9615C17.7052 27.7923 18.4863 28.6411 20.0984 29.7229L21.4279 30.6216L17.6055 36.3636H14.7636L18.2038 31.2374C16.2261 29.8228 15.1126 28.4414 15.1126 26.1113C15.1126 23.1987 17.1402 21.2181 20.9792 21.2181H24.8016V36.3636H24.8182Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpPaymentYandexpayAsset = forwardRef(PaymentYandexpayAsset);

export { VpPaymentYandexpayAsset as default };
